import { useCallback } from 'react';
import { ACTION_BY } from '../../../../../common/constant/constant';
import type { MetadataT } from '../../../../labelling/providers/stage-provider';
import { boundCoordinate } from '../../../../labelling/reducers/actionReducers/annotations/utils/bound-coordinate';
import type { AnnotationStoreT, AnnotationT } from '../../../../labelling/types';
import { Direction } from '../config';
import { ANNOTATION_MOVE_CONFIG } from '../config';
type UseShortcutKeysHandlersProps = {
  updateAnnotation: (annotationIdx: string, annotation: AnnotationT, metadata?: MetadataT) => void;
  selectedAnnotationIds: string[];
  annotationStore: AnnotationStoreT;
  stageDimensions: [number, number];
};
const useShortcutKeysHandlers = ({
  updateAnnotation,
  selectedAnnotationIds,
  annotationStore,
  stageDimensions
}: UseShortcutKeysHandlersProps) => {
  const moveBB = useCallback((direction: Direction) => {
    const [stageWidth, stageHeight] = stageDimensions;
    selectedAnnotationIds.forEach(id => {
      const annotation = annotationStore?.[id];
      if (!annotation || !annotation.data) return;
      const moveConfig = ANNOTATION_MOVE_CONFIG[annotation.annotationType];
      if (!moveConfig) {
        return;
      }
      const moveAnnotationBox = moveConfig[direction];
      const updatedAnnotation = {
        ...annotation,
        data: moveAnnotationBox(annotation.data)
      };
      if (updatedAnnotation.data === null) {
        return;
      }
      const boundedAnnotation = boundCoordinate((updatedAnnotation as AnnotationT), {
        width: stageWidth,
        height: stageHeight,
        rotation: 0
      });
      const metaData: MetadataT = {
        actionDuration: '0',
        actionBy: ACTION_BY.KEYBOARD
      };
      updateAnnotation(id, boundedAnnotation, metaData);
    });
  }, [stageDimensions, updateAnnotation, selectedAnnotationIds, annotationStore]);
  const onArrowLeftPress = useCallback(() => {
    moveBB(Direction.LEFT);
  }, [moveBB]);
  const onArrowRightPress = useCallback(() => {
    moveBB(Direction.RIGHT);
  }, [moveBB]);
  const onArrowUpPress = useCallback(() => {
    moveBB(Direction.UP);
  }, [moveBB]);
  const onArrowDownPress = useCallback(() => {
    moveBB(Direction.DOWN);
  }, [moveBB]);
  return {
    onArrowLeftPress,
    onArrowRightPress,
    onArrowUpPress,
    onArrowDownPress
  };
};
export default useShortcutKeysHandlers;